import Carousel from "nuka-carousel";
import React from "react";
import LeadersData from "../../data/LeadershipCarousel.json";
import "./Leadershipcarousel.css";

function Leadershipcarousel() {
 return (
  <div>
   <Carousel
    autoplay={true}
    className="carousel-container"
    renderCenterLeftControls={({ previousSlide }) => null}
    renderCenterRightControls={({ nextSlide }) => null}
    renderBottomCenterControls={({ previousSlide, nextSlide }) => (
     <div class="carousel-navigation">
      <img
       src={process.env.PUBLIC_URL + "/images/Home/leader-carousel/left-arrow.png"}
       alt="Previous"
       onClick={previousSlide}
      />
      <img
       src={process.env.PUBLIC_URL + "/images/Home/leader-carousel/right-arrow.png"}
       alt="Next"
       onClick={nextSlide}
      />
     </div>
    )}
   >
    <div className="main-carousel">
     {LeadersData.map((item) =>
      item["first-category"].map((leader) => (
       <div className="main-leader-container">
        <p>{leader["leader-message"]}</p>
        <div className="leader-details">
         <img
          className="leader-img"
          src={process.env.PUBLIC_URL + leader["leader-img"]}
          alt="leader1"
         />
         <div className="leader-details-wrap">
          <div className="leader-details-box">
           <strong>{leader["leader-name"]}</strong>
           <br />
           <span>{leader["leader-designation"]}</span>
          </div>
          <img
           className="leader-quotes"
           src={process.env.PUBLIC_URL + "/images/Home/leader-carousel/quotes.png"}
           alt="quotation"
          />
         </div>
        </div>
       </div>
      ))
     )}
    </div>
    <div className="main-carousel">
     {LeadersData.map((item) =>
      item["second-category"].map((leader) => (
       <div className="main-leader-container">
        <p>{leader["leader-message"]}</p>
        <div className="leader-details">
         <img
          className="leader-img"
          src={process.env.PUBLIC_URL + leader["leader-img"]}
          alt="leader1"
         />
         <div className="leader-details-wrap">
          <div className="leader-details-box">
           <strong>{leader["leader-name"]}</strong>
           <br />
           <span>{leader["leader-designation"]}</span>
          </div>
          <img
           className="leader-quotes"
           src={process.env.PUBLIC_URL + "/images/Home/leader-carousel/quotes.png"}
           alt="quotation"
          />
         </div>
        </div>
       </div>
      ))
     )}
    </div>
   </Carousel>
  </div>
 );
}

export default Leadershipcarousel;
